
import action from './action';
import Icon from 'vux/src/components/icon/index.vue'

import { yoButton } from 'components';
import { Tab, Tabs, List, Cell, CellGroup } from 'vant';

export default {
data() {
return {
dataList: [],
loading: false,
finished: true,
type: 0,
count: {},
active: 0,
page: []
};
},
created: async function () {
this.getInfo();
this.getEnterpriseInfo();
},
methods: {
...action
},
components: {
'van-tab': Tab,
'van-tabs': Tabs,
'van-list': List,
'van-cell': Cell
}
};



// WEBPACK FOOTER //
// ./src/module/summary/admin/page.vue